import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'lib-image-lib',
  templateUrl: './image-lib.component.html',
  styleUrls: ['./image-lib.component.css'],
})
export class ImageLibComponent implements OnInit {
  private image: any = null;
  public showMyImages: boolean = true;
  public showUnsplashSection: boolean = true;
  public isAddPhoto: boolean = false;
  public showLoader = false;

  constructor(
    public dialogRef: MatDialogRef<ImageLibComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.showUnsplashSection = this.data.showUnsplash;
  }

  ngOnInit(): void {}

  closeDailog(data = null): void {
    this.dialogRef.close(data);
  }

  selectedImage(image: any) {
    this.image = image;
    this.isAddPhoto = true;
  }

  selectedUnsplashImage(image: any) {
    let imgModel = {
      name: image.alt_description,
      file_id:0,// Default value
      properties: JSON.stringify({
        image_width: image.width,
        image_height: image.height,
        image_size: 0,
      }),
      url: image.urls.full,
    };
    this.image = imgModel;
    this.isAddPhoto = true;
  }

  addPhoto() {
    if (this.image != null) {
      this.closeDailog(this.image);
    } else {
      console.log('Please select image');
    }
  }

  changeSection(flag) {
    this.showMyImages = flag;
    this.isAddPhoto = false;
  }

  loaderState(event){
    if(event)
      this.showLoader = true;
    else
      this.showLoader = false;
  }
}
